import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as crypto from 'crypto-js'
import { Environment, EnvConfig } from '..';

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  viewMode = new BehaviorSubject("");

  defaultMode: string;
  constructor(@Inject(EnvConfig) private config: Environment) {
    this.defaultMode = localStorage.getItem('defaultView') || 'list';
    this.viewMode.next(this.defaultMode);
  }

  changeViewMode(data: string) {
    this.viewMode.next(data);
  }
  encryptLoginDetails(value: string) {
    const key = crypto.enc.Utf8.parse(this.config.passKey);
    const iv = crypto.enc.Utf8.parse(this.config.passValue);
    const b64 = crypto.AES.encrypt(crypto.enc.Utf8.parse(value), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: crypto.mode.CBC,
        padding: crypto.pad.Pkcs7
      }).toString();
    return b64;
  }

}
